import 'jquery';
import RSSParser from "rss-parser/dist/rss-parser.min";
import * as vars from '../../globals/variables';

import hbs_Newslist from '../../../hbs/news/list-view.hbs';
import hbs_NewsDetail from '../../../hbs/news/detail.hbs';
import hbs_Eventslist from '../../../hbs/events/list-view.hbs';
import hbs_EventsDetail from '../../../hbs/events/detail.hbs';

export function initLoader($container, type, subtype, feedUrl, callback) {
    const CORS_PROXY = "https://cors-anywhere.herokuapp.com/";
    let $loader = $container.find('.bn-loader'),
        $noResult = $container.find('.bn-no-result'),
        userAgent = window.location.host;

    let parser = new RSSParser({});
    parser.parseURL( feedUrl, function (err, feed) {
        if(err === null) {
            feed.trans = vars.ts;
            console.log(feed);

            $loader.remove();
            $noResult.remove();

            if (type === 'news') {
                if (subtype === 'list') {
                    $container.append(hbs_Newslist(feed));
                } else if (subtype === 'detail') {
                    $container.append(hbs_NewsDetail(feed));
                }
            } else if (type === 'events') {
                if (subtype === 'list') {
                    $container.append(hbs_Eventslist(feed));
                } else if (subtype === 'detail') {
                    $container.append(hbs_EventsDetail(feed));
                }
            }

            if(callback) {
                callback($container);
            }
        } else {
            console.error('Something went wrong here...');
            console.log(err);
            // show no result info and remove loader
            $loader.remove();
            $noResult.removeClass('hidden');
        }
    });
}



// WEBPACK FOOTER //
// ./source/js/utilities/lib/rss-loader.js